module.exports = __webpack_public_path__ + "static/media/logo_icon.shop.4f8820cd.svg";